import { z } from 'zod';

// One carrier entry, consumed by the per-building carriers mock (`mocks/locationCarriers.ts`) and
// by that read's schema once it is delivered. `id` is the INTEGER the deliveries filter sends
// (`deliveries.carrier_id` is an indexed FK); `name` is a display label and nothing else — it is
// never what a query is keyed by. The name arrives ready to render: already trimmed, already
// HTML-unescaped, and carrying a `(#id)` suffix when two live carriers share a name. The panel
// renders it verbatim rather than re-processing it, which is why there is no transform here:
// post-processing would strip the very suffix that tells the two apart.
export const CarrierOptionSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type CarrierOption = z.infer<typeof CarrierOptionSchema>;
